import { getSelectioAxios } from '@/main';

export default class GridService {

  async getGridDefinition(gridCode, parameters = {}) {
    return getSelectioAxios().post(`/grids/${gridCode}`, parameters)
      .then(response => response.data);
  }

  async getRiskOverview(idPortfolio, idPeriod) {
    const search = {
      'filters': [
        { 'fieldId': 'portfolioId', 'match': 'eq', 'value': parseInt(idPortfolio) },
        { 'fieldId': 'periodId', 'match': 'eq', 'value': parseInt(idPeriod) },
      ],
    };
    return getSelectioAxios().post('/grids/analysis-buyers/aggregations/risk-summary', search)
      .then(response => response.data);
  }

  async getGeographicAreaRiskSummaryByPortfolioAndPeriod(idPortfolio, idPeriod) {
    const search = {
      'filters': [
        { 'fieldId': 'portfolioId', 'match': 'eq', 'value': parseInt(idPortfolio) },
        { 'fieldId': 'periodId', 'match': 'eq', 'value': parseInt(idPeriod) },
      ],
    };
    return getSelectioAxios().post('/grids/analysis-buyers/aggregations/geographic-area-risk-summary', search)
      .then(response => response.data);
  }

  async getSectorsRiskSummaryByPortfolioAndPeriod(idPortfolio, idPeriod) {
    const search = {
      'filters': [
        { 'fieldId': 'portfolioId', 'match': 'eq', 'value': parseInt(idPortfolio) },
        { 'fieldId': 'periodId', 'match': 'eq', 'value': parseInt(idPeriod) },
      ],
    };
    return getSelectioAxios().post('/grids/analysis-buyers/aggregations/sector-risk-summary', search)
      .then(response => response.data);
  }

  async getLatePIndexRiskSummaryByPortfolioAndPeriod(idPortfolio, idPeriod) {
    const search = {
      'filters': [
        { 'fieldId': 'portfolioId', 'match': 'eq', 'value': parseInt(idPortfolio) },
        { 'fieldId': 'periodId', 'match': 'eq', 'value': parseInt(idPeriod) },
      ],
    };
    return getSelectioAxios().post('/grids/analysis-buyers/aggregations/late-pindex-risk-summary', search)
      .then(response => response.data);
  }

  async getClaimSeverityRiskSummaryByPortfolioAndPeriod(idPortfolio, idPeriod) {
    const search = {
      'filters': [
        { 'fieldId': 'portfolioId', 'match': 'eq', 'value': parseInt(idPortfolio) },
        { 'fieldId': 'periodId', 'match': 'eq', 'value': parseInt(idPeriod) },
      ],
    };
    return getSelectioAxios().post('/grids/analysis-buyers/aggregations/claim-severity-risk-summary', search)
      .then(response => response.data);
  }

  async getEconomicRiskSummaryByPortfolioAndPeriod(idPortfolio, idPeriod) {
    const search = {
      'filters': [
        { 'fieldId': 'portfolioId', 'match': 'eq', 'value': parseInt(idPortfolio) },
        { 'fieldId': 'periodId', 'match': 'eq', 'value': parseInt(idPeriod) },
      ],
    };
    return getSelectioAxios().post('/grids/analysis-buyers/aggregations/economic-risk-summary', search)
      .then(response => response.data);
  }

  async getAnalysisBuyersSearch(search, axiosConfig = {}) {
    return getSelectioAxios().post('/grids/analysis-buyers/search', search, axiosConfig);
  }

  async getPortfolioBuyersSearch(search) {
    return getSelectioAxios().post('/grids/portfolio-buyers/search', search)
      .then(response => response.data);
  }

  async getUnmatchedBuyersSearch(search) {
    return getSelectioAxios().post('/grids/unmatched-buyers/search', search)
      .then(response => response.data);
  }

  async getIconContractSearch(search) {
    return getSelectioAxios().post('/grids/icon-contracts/search', search)
      .then(response => response.data);
  }

  async getPortfoliosSearch(search) {
    return getSelectioAxios().post('/grids/portfolio-list/search', search)
      .then(response => response.data);
  }

}
